import { requestConfig } from "../config.js";

/**
 * Авторизация пользователя через мастер
 *
 * @param {String} customerKey
 */
export async function apiAuthByCustomerKey(customerKey) {
  const response = await requestConfig.post("/api/v0/master/mobile_connect/auth_by_customer_key/", {
    key: customerKey,
  });

  return response.data?.detail;
}

/**
 * Авторизация через портал
 *
 * @param {Number} contractId
 * @param {String} billingId
 */
export async function apiAuthByPortal(contractId, billingId) {
  const response = await requestConfig.post("/api/v0/ipoe-portal/auth/contract", {
    billing: billingId,
    contract: contractId,
  });

  return response.data;
}
